<template>
  <div style="display: contents">
    <tr>
      <td colspan="10">
        <div style="height: 0.5rem"></div>
      </td>
    </tr>
    <tr class="rbu-section-extra-item-module-row">
      <td class="rbu-section-extra-item-column-order">
        <v-btn v-if="idx !== 0" icon color="primary" @click="$emit('up')">
          <v-icon>mdi-arrow-up-thin</v-icon>
        </v-btn>
        <v-btn
          v-if="idx !== total - 1"
          icon
          color="primary"
          @click="$emit('down')"
        >
          <v-icon>mdi-arrow-down-thin</v-icon>
        </v-btn>
      </td>
      <td class="rbu-section-extra-item-column-dum-no">
        <v-text-field
          outlined
          dense
          hide-details
          auto-grow
          :value="item.dummy_item_no"
          @input="onUpdate({ dummy_item_no: $event })"
        ></v-text-field>
      </td>
      <td class="rbu-section-extra-item-column-type">
        <v-select
          outlined
          dense
          hide-details
          placeholder="$ / %"
          :items="typeOptions"
          :value="item.type"
          @input="onUpdate({ type: $event })"
        ></v-select>
      </td>
      <td class="rbu-section-extra-item-column-index">
        {{ idx + 1 }}
      </td>
      <td class="rbu-section-extra-item-column-item-descriptions">
        <v-textarea
          outlined
          dense
          hide-details
          auto-grow
          rows="1"
          placeholder="Item Descriptions (Only Update in Template)"
          :value="item.item_description"
          @input="onUpdate({ item_description: $event })"
          :disabled="true"
        ></v-textarea>
      </td>
      <td class="rbu-section-extra-item-column-reference">
        <div style="display: flex; flex-direction: column">
          <span>{{ item.reference || "-" }}</span>
          <!-- <span
            v-for="(related_item, index) in item.related_items"
            class="styled-span"
            style="margin-top: 2px; width: fit-content"
            @click="() => goReferenceItem(related_item)"
            :key="index"
          >
            {{ related_item.current_item_no }}
          </span> -->
        </div>
      </td>
      <td class="rbu-section-extra-item-column-value">
        {{ converted_item_value }}
      </td>
      <td class="rbu-section-extra-item-column-formula">
        <v-textarea
          outlined
          dense
          hide-details
          auto-grow
          rows="1"
          placeholder="Formula"
          :value="item.formula"
          @input="onUpdate({ formula: $event })"
        ></v-textarea>
      </td>
      <td class="rbu-section-extra-item-column-descriptions">
        <v-textarea
          outlined
          dense
          hide-details
          auto-grow
          rows="1"
          placeholder="Descriptions"
          :value="item.descriptions"
          @input="onUpdate({ descriptions: $event })"
        ></v-textarea>
      </td>
      <td class="rbu-section-extra-item-column-action">
        <v-btn
          icon
          color="primary"
          @click="$refs.fileInput.click()"
          v-if="!item.file"
        >
          <v-icon>mdi-upload</v-icon>
        </v-btn>
        <span v-else>
          <span
            class="rbu-section-extra-item-module-file"
            style="vertical-align: middle; margin-bottom: 0.3rem"
            @click="showFile(item.file)"
            >{{
              item.file instanceof File ? item.file.name : item.file.filename
            }}</span
          >
          <v-btn icon small color="primary" @click="onUpdate({ file: null })">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </span>
        <input type="file" hidden ref="fileInput" @change="onFileInputChange" />

        <v-btn icon color="primary" @click="$emit('delete', idx)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </td>
    </tr>
    <tr>
      <td colspan="10">
        <div style="height: 0.5rem"></div>
      </td>
    </tr>
  </div>
</template>
<script>
import { computed, inject, ref, watch } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";

export default {
  name: "RbuExtraItemRow",
  components: {},
  props: {
    item: Object,
    idx: Number,
    total: Number,
  },
  setup(props, { root, emit }) {
    const typeOptions = ["%", "$"];
    const fileInput = ref();
    const onFileInputChange = async function (e) {
      const FILE_SIZE_LIMITED = 2 * 1024 * 1024;
      const file = e.target.files[0];
      if (file.size > FILE_SIZE_LIMITED) {
        e.target.value = "";
        alert("The file size must not exceed 2MB.");
      } else {
        fileInput.value.value = "";
        if (file) {
          onUpdate({
            file,
          });
        }
      }
    };
    const showFile = function (file) {
      if (file instanceof File) {
        const url = URL.createObjectURL(file);
        window.open(url, "_blank");
      } else {
        root.$downloadFile(file.id);
      }
    };

    const converted_item_value = computed(() => {
      try {
        if (props.item.type === "%") {
          return `${props.item.value}%`;
        } else if (props.item.type === "$") {
          return `$${props.item.value}`;
        } else {
          return `${props.item.value}`;
        }
      } catch (e) {
        console.log(e);
        return "0";
      }
    });

    const onUpdate = _.debounce(function (evt) {
      console.log("Extra item Row Update: ", evt);
      let updates = {
        ...props.item,
        ...evt,
      };

      let value = 0;

      if (updates.formula) {
        try {
          value = eval(updates.formula).toFixed(2);
        } catch (e) {
          value = 0;
          console.debug(e);
        }
      } else {
        value = 0;
      }

      updates.value = value;
      emit("update", updates);
    }, 500);

    const goReferenceItem = async function (item) {
      root.$router.push({ name: "rbu-item", params: { itemId: item.id } });
    };

    return {
      typeOptions,
      converted_item_value,
      //   subTotalPercentage,
      //   formulaPrefix,
      //   formulaSuffix,
      //   onFormulaUpdate,
      //   onPeriodUpdate,
      //   onDatapointUpdate,
      goReferenceItem,
      fileInput,
      onFileInputChange,
      showFile,
      onUpdate,
      File,
      //   resultPercentage,
      //   parsedFormula,
    };
  },
};
</script>

<style lang="less">
.rbu-section-extra-item-module-row {
  td {
    padding: 0 8px;
  }

  .rbu-section-extra-item-column-order {
    align-content: center;
  }

  .rbu-section-extra-item-column-dum-no {
    align-content: center;
    // width: 10%;
  }

  .rbu-section-extra-item-column-type {
    align-content: center;
    // width: 10%;
  }

  .rbu-section-extra-item-column-item-descriptions {
    align-content: center;
  }

  .rbu-section-extra-item-column-reference {
    align-content: center;
  }

  .rbu-section-extra-item-column-index {
    align-content: center;
    // width: 5%;
  }

  .rbu-section-extra-item-column-value {
    align-content: center;
    // width: 10%;
  }

  .rbu-section-extra-item-column-formula {
    align-content: center;
    // width: 15%;
  }

  .rbu-section-extra-item-column-descriptions {
    align-content: center;
    // width: 20%;
  }

  .rbu-section-extra-item-column-action {
    align-content: center;
    // width: 30%;

    .rbu-section-extra-item-module-file {
      // font-size: 80%;
      font-size: 100%;
      word-break: break-all;
      text-decoration: underline;
      color: var(--v-primary-base);
      cursor: pointer;
      max-width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: inline-block;
      text-wrap: wrap;
    }
  }
}

.styled-span {
  cursor: pointer; /* Mouse pointer on hover */
  color: red; /* Red text */
  text-decoration: underline; /* Underline text */
}

.styled-span:hover {
  color: darkred; /* Optional: Darker red text on hover */
}
</style>
